/**
* @Author: Dmytro Mykhailov <MSL_Chaos>
* @Date:   2016-10-02T03:15:34+03:00
* @Email:  belindream@gmail.com
* @Project: Lumand
* @Last modified by:   dmitriymikhaylov
* @Last modified time: 2016-10-09T02:15:45+03:00
* @License: MIT
*/



import createReducer from 'utils/redux/createReducer'

const initialState = {
    item: {
    },
    hideItem: {

    }
}

export default createReducer(initialState, {
  PUSH_POPUP: (currentState, action) => ({
      item: action.data
    , hideItem: currentState.item
  }),
  'DISMISS_POPUP': (currentState, action) => ({
      item: {}
    , hideItem: currentState.item
  })
})



// WEBPACK FOOTER //
// ./src/reducers/popup.js